import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ai-subscription-modal',
  templateUrl: './ai-subscription-modal.component.html',
  styleUrls: ['./ai-subscription-modal.component.css']
})
export class AiSubscriptionModalComponent {
  nombre = '';
  apellido = '';
  submitted = false;

  constructor(public activeModal: NgbActiveModal) {}

  get isValid(): boolean {
    return this.nombre.trim().length > 0 && this.apellido.trim().length > 0;
  }

  submit() {
    this.submitted = true;
    if (!this.isValid) return;
    localStorage.setItem('safecloud_ai_user', JSON.stringify({
      nombre: this.nombre.trim(),
      apellido: this.apellido.trim(),
      registeredAt: new Date().toISOString()
    }));
    this.activeModal.close('registered');
  }
}
